import React from 'react';

// Receives userEmail and onLogout function as props from App.js
function HomePage({ userEmail, onLogout }) {
  return (
    <div className="form-container" style={{ textAlign: 'center' }}>
      <h2>Home Page</h2>
      {userEmail ? (
        <p>Welcome, <strong>{userEmail}</strong>!</p>
      ) : (
        <p>Welcome! You are logged in.</p>
      )}
      <p>This is your protected home page content.</p>
      {onLogout && (
        <button 
          onClick={onLogout} 
          style={{
            marginTop: '20px', 
            padding: '10px 20px', 
            backgroundColor: '#dc3545', // A red color for logout
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
          onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c82333'}
          onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#dc3545'}
        >
          Logout
        </button>
      )}
    </div>
  );
}

export default HomePage; 